import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import fetchAPI from '../../../lib/utils/fetch-api'
import { platformAdminHash } from './platform-admin-redirect'

type Meta = {
  platform_admin_host?: string | null
  control_plane_external?: boolean
}

function adminBaseUrl(host: string): string {
  const h = String(host || '')
    .trim()
    .replace(/^https?:\/\//i, '')
    .replace(/\/+$/, '')
  return `https://${h}/`
}

type Props = {
  /** @deprecated Local ERP control-plane UI removed; kept for call-site compat. */
  Local?: React.ComponentType
}

/**
 * Control-plane dealers UI lives on platform-admin.
 * Always redirect when host is known; otherwise show a short moved notice (no Local fallback).
 */
export default function DealersControlPlaneGate(_props: Props) {
  const { tenantId, quizId } = useParams<{ tenantId?: string; quizId?: string }>()
  const [status, setStatus] = useState<'pending' | 'redirect' | 'missing'>('pending')
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    const go = (host: string) => {
      const base = adminBaseUrl(host)
      const hash = platformAdminHash(window.location.pathname, { tenantId, quizId })
      window.location.replace(`${base}${hash}`)
    }

    ;(async () => {
      const baked = String(process.env.REACT_APP_PLATFORM_ADMIN_HOST || '').trim()
      if (baked) {
        if (!cancelled) {
          setStatus('redirect')
          go(baked)
        }
        return
      }

      try {
        const res = await fetchAPI('/api/dealers/admin/meta')
        const meta = (res?.data || res) as Meta
        const host = String(meta?.platform_admin_host || '').trim()
        if (host) {
          if (!cancelled) {
            setStatus('redirect')
            go(host)
          }
          return
        }
        if (!cancelled) setStatus('missing')
      } catch (e: any) {
        if (!cancelled) {
          setError(e?.message || null)
          setStatus('missing')
        }
      }
    })()

    return () => {
      cancelled = true
    }
  }, [tenantId, quizId])

  if (status === 'missing') {
    return (
      <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif', maxWidth: 520 }}>
        <h2 style={{ marginTop: 0 }}>Панель дилеров перенесена</h2>
        <p>
          Staff control-plane открывается на PLATFORM_ADMIN_HOST (base). Задайте{' '}
          <code>REACT_APP_PLATFORM_ADMIN_HOST</code> / <code>PLATFORM_ADMIN_HOST</code>.
        </p>
        {error ? <p style={{ color: '#b42318' }}>{error}</p> : null}
      </div>
    )
  }

  return (
    <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
      <p>{status === 'redirect' ? 'Переход в панель платформы…' : 'Проверка control-plane…'}</p>
    </div>
  )
}
